import { Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

function PrivacyPolicy(props) {
    var { pathname } = useLocation();

    return (
        <Fragment>
            <div
                id="kt_body"
                data-bs-spy="scroll"
                data-bs-target="#kt_landing_menu"
                className="bg-body position-relative"
            >
                <div className="d-flex flex-column flex-root">
                    <div className="mb-0" id="home">
                        <div className="bgi-no-repeat bgi-size-contain bgi-position-x-center bgi-position-y-bottom landing-dark-bg">
                            <div
                                className="landing-header"
                                data-kt-sticky="true"
                                data-kt-sticky-name="landing-header"
                                data-kt-sticky-offset="{default: '200px', lg: '300px'}"
                            >
                                <div className="container">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center flex-equal">
                                            <button
                                                className="btn btn-icon btn-active-color-primary me-3 d-flex d-lg-none"
                                                id="kt_landing_menu_toggle"
                                            >
                                                <i className="ki-outline ki-abstract-14 fs-2hx"></i>
                                            </button>
                                            <Link to="/">
                                                <img
                                                    alt="Logo"
                                                    src={require("components/assets/media/custom/logo.png")}
                                                    className="logo-default h-60px h-lg-60px"
                                                />
                                                <img
                                                    alt="Logo"
                                                    src={require("components/assets/media/custom/logo.png")}
                                                    className="logo-sticky h-20px h-lg-25px"
                                                />
                                            </Link>
                                        </div>
                                        <div className="d-lg-block" id="kt_header_nav_wrapper">
                                            <div
                                                className="d-lg-block p-5 p-lg-0"
                                                data-kt-drawer="true"
                                                data-kt-drawer-name="landing-menu"
                                                data-kt-drawer-activate="{default: true, lg: false}"
                                                data-kt-drawer-overlay="true"
                                                data-kt-drawer-width="200px"
                                                data-kt-drawer-direction="start"
                                                data-kt-drawer-toggle="#kt_landing_menu_toggle"
                                                data-kt-swapper="true"
                                                data-kt-swapper-mode="prepend"
                                                data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav_wrapper'}"
                                            >
                                                <div
                                                    className="menu menu-column flex-nowrap menu-rounded menu-lg-row menu-title-gray-600 menu-state-title-primary nav nav-flush fs-5 fw-semibold"
                                                    id="kt_landing_menu"
                                                >
                                                    <div className="menu-item">
                                                        <Link
                                                            className="menu-link nav-link active py-3 px-4 px-xxl-6"
                                                            to="#"
                                                            data-kt-scroll-toggle="true"
                                                            data-kt-drawer-dismiss="true"
                                                        >
                                                            Home
                                                        </Link>
                                                    </div>
                                                    <div className="menu-item">
                                                        <Link
                                                            className="menu-link nav-link py-3 px-4 px-xxl-6"
                                                            to="https://cotik.gitbook.io/docs"
                                                            data-kt-scroll-toggle="true"
                                                            data-kt-drawer-dismiss="true"
                                                        >
                                                            How it Works
                                                        </Link>
                                                    </div>
                                                    <div className="menu-item">
                                                        <Link
                                                            className="menu-link nav-link py-3 px-4 px-xxl-6"
                                                            to="/privacy-policy"
                                                            data-kt-scroll-toggle="true"
                                                            data-kt-drawer-dismiss="true"
                                                        >
                                                            Privacy Policy
                                                        </Link>
                                                    </div>
                                                    <div className="menu-item">
                                                        <Link
                                                            className="menu-link nav-link py-3 px-4 px-xxl-6"
                                                            to="/terms-of-service"
                                                            data-kt-scroll-toggle="true"
                                                            data-kt-drawer-dismiss="true"
                                                        >
                                                            Terms of Service
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-equal text-end ms-1">
                                            <Link
                                                to={
                                                    pathname.indexOf("/extension") > -1
                                                        ? "/admin/extension-etsy"
                                                        : "/admin"
                                                }
                                                className="btn btn-success"
                                            >
                                                Sign In
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="landing-curve landing-dark-color mb-10 mb-lg-20">
                            <svg viewBox="15 12 1470 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M0 11C3.93573 11.3356 7.85984 11.6689 11.7725 12H1488.16C1492.1 11.6689 1496.04 11.3356 1500 11V12H1488.16C913.668 60.3476 586.282 60.6117 11.7725 12H0V11Z"
                                    fill="currentColor"
                                ></path>
                            </svg>
                        </div>
                        <div className="mt-20 position-relative z-index-2">
                            <div className="container">
                                <div className="text-center mb-17">
                                    <h2
                                        className="fs-2hx text-gray-900 mb-5"
                                        id="clients"
                                        data-kt-scroll-offset="{default: 125, lg: 150}"
                                    >
                                        Privacy policy for COTIK
                                    </h2>
                                    <div className="fs-5 text-muted fw-bold">
                                        We work hard to keep all our legal mumbo jumbo as simple as possible, but we
                                        <br />
                                        still have to have it.
                                    </div>
                                    <p className="text-muted ">Last updated November, 2025</p>
                                </div>
                                <div className="mx-15 mb-4">
                                    <p>This Privacy Policy explains how <strong>Generations Ecom LLC</strong> (“we”, “our”, “us”) collects, uses, stores, and protects information when you use our website <strong>https://cotik.app</strong> and our application <strong>COTIK</strong> (collectively “the Service”). By using the Service, you agree to the practices described in this Privacy Policy.</p>

                                    <hr />

                                    <h2>1. Information We Collect</h2>

                                    <h3>1.1 Information You Provide</h3>
                                    <p>We may collect your name, email address, business information, and any other details you voluntarily submit when using the Service. We do not collect sensitive personal data.</p>

                                    <h3>1.2 Platform Data (Etsy & TikTok Shop)</h3>

                                    <p><strong>From Etsy (via Etsy API):</strong></p>
                                    <ul>
                                        <li>Listing information (title, price, description, images, variations)</li>
                                        <li>Shop information and settings</li>
                                        <li>Order summaries</li>
                                        <li>Sales metrics</li>
                                    </ul>
                                    <p>We do NOT store Etsy buyer personal data unless explicitly permitted by Etsy.</p>

                                    <p><strong>From TikTok Shop (via TikTok Shop API):</strong></p>
                                    <ul>
                                        <li>Product information (name, price, SKU, inventory levels)</li>
                                        <li>Order details (order ID, purchase time, fulfillment status)</li>
                                        <li>Shop information</li>
                                    </ul>
                                    <p>If TikTok Shop provides buyer PII (name, phone, address) for shipping, we use it ONLY for order fulfillment and do not store, reuse, or share it except as required by TikTok Shop API policies.</p>

                                    <h3>1.3 Automatically Collected Data</h3>
                                    <p>We may collect IP address, device information, browser version, usage logs, and cookies (see Section 7).</p>

                                    <hr />

                                    <h2>2. How We Use Your Information</h2>
                                    <ul>
                                        <li>Operating and improving the Service</li>
                                        <li>Creating or updating product listings</li>
                                        <li>Displaying order and sales information</li>
                                        <li>Inventory or fulfillment syncing</li>
                                        <li>Providing customer support</li>
                                    </ul>
                                    <p>We do not resell or misuse platform data.</p>

                                    <hr />

                                    <h2>3. Data Storage & Retention</h2>
                                    <p>We store only the minimum required data. Platform data may be cached temporarily and refreshed according to Etsy and TikTok API policies. You may request deletion at any time.</p>

                                    <hr />

                                    <h2>4. Data Protection & Security</h2>
                                    <p>We use reasonable security measures such as HTTPS encryption, secure servers, limited access, and monitoring. No system is completely secure, but we take all reasonable precautions.</p>

                                    <hr />

                                    <h2>5. Data Sharing</h2>
                                    <p>We do not sell, share, or transfer your data to third parties except where required by law.</p>

                                    <hr />

                                    <h2>6. Buyer Data (Etsy & TikTok)</h2>

                                    <p><strong>Etsy:</strong> We do not collect or store Etsy buyer personal information.</p>

                                    <p><strong>TikTok Shop:</strong> Buyer details provided for shipping are used ONLY for order fulfillment and protected according to TikTok policies.</p>

                                    <hr />

                                    <h2>7. Cookies</h2>
                                    <p>We use cookies for login sessions, user experience improvements, and analytics. Disabling cookies may reduce functionality.</p>

                                    <hr />

                                    <h2>8. Children’s Privacy</h2>
                                    <p>The Service is not intended for users under 13 years of age.</p>

                                    <hr />

                                    <h2>9. Third-Party Services</h2>
                                    <p>The Service integrates with Etsy and TikTok Shop. Their data practices are governed by their respective policies.</p>

                                    <hr />

                                    <h2>10. Your Rights</h2>
                                    <p>You may request access, correction, deletion, or account removal at any time by contacting:</p>
                                    <p><strong>Email:</strong> support@cotik.app</p>

                                    <hr />

                                    <h2>11. Changes to This Policy</h2>
                                    <p>We may update this Privacy Policy. Significant updates will be notified via email or on our website.</p>

                                    <hr />

                                    <h2>12. Contact</h2>
                                    <p><strong>Email:</strong> support@cotik.app</p>
                                    <p><strong>Company:</strong> Generations Ecom LLC</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicy);
